import { OktonSimpleCrudList } from '@okton/platform-ui';
import { Building2 } from 'lucide-react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import BankAppPage from '../../layout/BankAppPage';
import {
  useDeleteDepartamento,
  useDepartamentos,
} from '../../services/hooks/useCadastros';

const Departamentos = () => {
  const history = useHistory();
  const {
    data: departamentos = [],
    isLoading,
    isError,
    refetch,
  } = useDepartamentos();
  const deleteMutation = useDeleteDepartamento();

  return (
    <BankAppPage>
      <>
        <OktonSimpleCrudList
          horizontalSpacing={0}
          title="Departamentos"
          description="Classificação por departamento dos lançamentos"
          newLabel="Novo Departamento"
          onNew={() => history.push('/departamentos/novo')}
          onEdit={id => history.push(`/departamentos/${id}`)}
          icon={Building2}
          emptyMessage="Nenhum departamento cadastrado"
          items={departamentos.map(d => ({ id: d.id_dpt, name: d.nome_dpt }))}
          loading={isLoading}
          error={isError}
          onRetry={refetch}
          onDelete={id => deleteMutation.mutateAsync(id)}
          deleteConfirmation="Excluir este Departamento do IFLEX?"
        />
      </>
    </BankAppPage>
  );
};

export default Departamentos;
